"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMESTAMPED_FIELDS = exports.DEFAULT_HEADERS = exports.DEFAULT_PAGINATION = exports.DEFAULT_CORS_MODE = exports.cacheMode = exports.corsMode = void 0;
var corsMode = {
  cors: 'cors',
  noCors: 'no-cors',
  sameOrigin: 'same-origin'
};
exports.corsMode = corsMode;
var cacheMode = {
  "default": 'default',
  noStore: 'no-store',
  reload: 'reload',
  noCache: 'no-cache',
  forceCache: 'force-cache'
};
exports.cacheMode = cacheMode;
var DEFAULT_CORS_MODE = corsMode.cors;
exports.DEFAULT_CORS_MODE = DEFAULT_CORS_MODE;
var DEFAULT_PAGINATION = {
  page: 0,
  limit: 25
};
exports.DEFAULT_PAGINATION = DEFAULT_PAGINATION;
var DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'
};
exports.DEFAULT_HEADERS = DEFAULT_HEADERS;
var TIMESTAMPED_FIELDS = ['insertTime', 'updateTime', 'statusUpdateTime'];
exports.TIMESTAMPED_FIELDS = TIMESTAMPED_FIELDS;
//# sourceMappingURL=constants.js.map